import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ToastNotification";
import { api } from "@/lib/api";
import { useEffect, useState } from "react";
import { EspecialidadeEditProps } from "./interface/Especialidade.interface";

const EspecialidadeEdit = ({ open, onOpenChange, especialidade, onSuccess }: EspecialidadeEditProps) => {

  const [formData, setFormData] = useState({
    nome: "",
    codigo: "",
    descricao: "",
    ativo: true,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (especialidade) {
      setFormData({
        nome: especialidade.nome || "",
        codigo: especialidade.codigo || "",
        descricao: especialidade.descricao || "",
        ativo: especialidade.ativo ?? true,
      });
    } else {
      setFormData({
        nome: "",
        codigo: "",
        descricao: "",
        ativo: true,
      });
    }
  }, [especialidade, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        nome: formData.nome,
        descricao: formData.descricao || undefined,
        ativo: formData.ativo,
      };

      if (especialidade) {
        await api.put(`/api/especialidades/${especialidade.id}`, payload);
        toast.success("Especialidade atualizada com sucesso!");
      } else {
        await api.post("/api/especialidades", payload);
        toast.success("Especialidade criada com sucesso!");
      }

      onSuccess();
      onOpenChange(false);
    } catch (error: any) {
      console.error("Erro ao salvar especialidade:", error);
      toast.error(error?.message || "Erro ao salvar a especialidade");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{especialidade ? "Editar Especialidade" : "Nova Especialidade"}</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Nome */}
          <div className="space-y-2">
            <Label htmlFor="nome">Nome *</Label>
            <Input
              id="nome"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Ex: Retinologia"
              maxLength={100}
              required
            />
            <p className="text-xs text-muted-foreground">
              Nome da especialidade (máximo 100 caracteres)
            </p>
          </div>

          {/* Descrição */}
          <div className="space-y-2">
            <Label htmlFor="descricao">Descrição</Label>
            <Textarea
              id="descricao"
              value={formData.descricao}
              onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
              placeholder="Descrição detalhada da especialidade médica"
              rows={4}
            />
            <p className="text-xs text-muted-foreground">
              Descrição opcional da especialidade
            </p>
          </div>

          {/* Status */}
          <div className="flex items-center space-x-2">
            <Switch
              id="ativo"
              checked={formData.ativo}
              onCheckedChange={(checked) => setFormData({ ...formData, ativo: checked })}
            />
            <Label htmlFor="ativo">Ativo</Label>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Salvando..." : especialidade ? "Atualizar" : "Criar"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EspecialidadeEdit;
